import { render } from "./Weight.vue?vue&type=template&id=7e412191"
import script from "./Weight.vue?vue&type=script&lang=js"
export * from "./Weight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__